import InstagramForm from "./instagramForm.container";

export default InstagramForm;
